import React from 'react';

import AddOrEditInsurance from '../../../Insurance/AddOrEditInsurance';

export default function Insurance({ lenderId }) {
  return <AddOrEditInsurance lenderId={lenderId} />;
}
